import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import InputLabel from '../../../../components/form/InputLabel';
import ButtonGroup from '../../../../components/Modal/ModalButtonGroups/ButtonGroup';
import SearchableDropdownMenu from '../../../../components/SearchableDropdownMenu';
import { Statuses } from '../../../../constants/statuses';
import { createToast } from '../../../../redux/modules/app';
import { getJobStats } from '../../../../redux/modules/jobs';
import { jobSearch } from '../../../../redux/modules/jobSearch';
import { hideModal } from '../../../../redux/modules/modal';
import { jobDetailsSearch } from '../../../../redux/reducer';
import { useTransferRecordProject } from '../../../../services/record-service';
import { getJobLabel } from '../../../../utils/jobUtil';

const TransferRecordProjectModal = ({ companyId, recordId, insuredId, jobId }) => {
  const dispatch = useDispatch();
  const jobs = useSelector(jobSearch.selectData);
  const pageInfo = useSelector(jobSearch.selectPageInfo);
  const [selectedJob, setSelectedJob] = useState({ name: '', id: null });

  const { mutateAsync: transferRecordProject } = useTransferRecordProject({ recordId, insuredId });

  useEffect(() => {
    dispatch(jobSearch.setBaseFilters([
      { key: 'company.id', value: companyId },
      { key: 'status', value: Statuses.Active }
    ]));

    dispatch(jobSearch.getPage());
  }, [companyId]);

  const onSubmit = async () => {
    const { id: selectedJobId } = selectedJob;
    if (!selectedJobId) {
      return dispatch(createToast({
        title: 'Please select a project first',
        status: 'warning'
      }));
    }

    await transferRecordProject(selectedJobId);

    dispatch(jobDetailsSearch.getPage());
    dispatch(getJobStats(jobId));

    return dispatch(hideModal());
  };

  return (
    <Box>
      <Box mb={4}>
        <Text>Select where you would like to transfer this record:</Text>
      </Box>
      <Box mb={8}>
        <InputLabel labelName="Select Project" />
        <SearchableDropdownMenu
          matchWidth
          data={jobs}
          endMessage={(
            <Text color="greyScale.500" pt={2} textAlign="center" textStyle="bodySm">
              {`Showing All (${pageInfo.total})`}
            </Text>
          )}
          fetchNextData={() => dispatch(jobSearch.getPage({ page: pageInfo.currentPage + 1 }))}
          hasMore={pageInfo.hasMore}
          idKey="id"
          isDisabled={false}
          labelKey={getJobLabel}
          searchBlueprint={jobSearch}
          selected={getJobLabel(selectedJob)}
          truncateMenuItems={false}
          width="100%"
          onSelect={setSelectedJob}
        />
      </Box>

      <Box>
        <ButtonGroup
          secondaryClick={() => dispatch(hideModal())}
          onClick={onSubmit}
        />
      </Box>
    </Box>
  );
};

TransferRecordProjectModal.propTypes = {
  companyId: PropTypes.number.isRequired,
  recordId: PropTypes.number.isRequired,
  insuredId: PropTypes.number,
  jobId: PropTypes.number
};

export default TransferRecordProjectModal;
